import React from 'react';
import { FileIcon } from 'elements/Icon';

const Audio = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z" />
    <g>
      <polygon points="41.8,47.8 12.7,98.2 70.8,98.2 	" />
      <polygon points="63.3,59.3 40.9,98.2 85.8,98.2 	" />
      <circle cx="78.7" cy="48.9" r="7.1" />
    </g>
  </FileIcon>
);

export default Audio;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/types/Image.jsx